
import { AppState, RouteParam, routeParams, UserAttrs } from 'cdx-common';
import { HomeView } from 'home';
import React from 'react';
import { useSelector } from 'react-redux';
import { createBrowserRouter, RouteObject, RouterProvider, useRevalidator } from "react-router-dom";

import { Labeler, } from 'views/labeler/labeler';
import { NotFound } from './NotFound';
import { LoadingView, NoConnectionView, OnErrorView } from './libraries/MainViewLoader';
import { clearRouteData, ensureRouteData } from './libraries/RouteManager';
import { useSession } from './libraries/SessionProvider';
import { UploadTest } from './views/UploadTest';
import { LoginView } from './views/auth/LoginView';
import { SystemLogin } from './views/auth/SystemAuth';
import { Companies } from './views/companies/Companies';
import { Company } from './views/companies/Company';
import { Contact } from './views/contacts/Contact';
import { Contacts } from './views/contacts/Contacts';
import { LabelerPrint } from './views/labeler/LabelerPrint';
import { ProductList } from './views/product/ProductList';
import { ProjectPage, ProjectSection } from './views/project/ProjectView';
import { ScanProductsModeView } from './views/scanner/ScannerModeView';
import { AppSettings } from './views/settings/AppSettings';
import { UserView } from './views/user/User';
import { Users } from './views/user/UserList';



/*
const AppRoute = (routeParam: RouteParam, element: React.ReactNode): React.ReactNode => {
    return <React.Fragment>{[routeParam.path].concat(Object.values(routeParam?.paths ?? {}).filter(p => typeof p == 'string')).map(p => <Route loader={(params) => {
        console.log('Route LOADER');
        return appRouteLoader(params, routeParam);
    }} key={p} path={p} element={element} />)}</React.Fragment>;
};
*/
const RouteLoadError = () => {
    const revalidator = useRevalidator();
    return <OnErrorView onReload={() => revalidator.revalidate()} />;
};

const appDataRoute = (routeParam: RouteParam, element: React.ReactNode): RouteObject[] => {
    return [routeParam.path].concat(Object.values(routeParam?.paths ?? {}).filter(p => typeof p == 'string')).map(p => {
        return {
            path: p,
            element: element,
            errorElement: <RouteLoadError />,
            hydrateFallbackElement: <LoadingView />,
            loader: routeParam.loader === false ? undefined : async ({ request }) => {
                await ensureRouteData(request.url);
                return null;
            }
        };
    });
};

const generateRoutes = (isSuperAdmin: boolean, user: UserAttrs | undefined): RouteObject[] => {

    let routes: RouteObject[] = [];
    /*
    routes = routes.concat(appDataRoute(routeParams.projectList, <ProjectList />));
    routes = routes.concat(appDataRoute(routeParams.userInvitation, <UserInvitation />));
    
    routes = routes.concat(appDataRoute(routeParams.verifySelectDevice, <VerifyAccountView />));
    routes = routes.concat(appDataRoute(routeParams.verifyCode, <VerifyCodeView />));
    */
    routes = routes.concat(appDataRoute(routeParams.login, <LoginView />));
    routes = routes.concat(appDataRoute(routeParams.home, <HomeView />));

    if (user) {
        routes = routes.concat(appDataRoute(routeParams.users, <Users />));
        routes = routes.concat(appDataRoute(routeParams.products, <ProductList />));
        routes = routes.concat(appDataRoute(routeParams.user, <UserView />));
        routes = routes.concat(appDataRoute(routeParams.project, <ProjectPage section={ProjectSection.contacts} />));
        routes = routes.concat(appDataRoute(routeParams.projectContacts, <ProjectPage section={ProjectSection.contacts} />));
        routes = routes.concat(appDataRoute(routeParams.projectQuotes, <ProjectPage section={ProjectSection.quotes} />));
        routes = routes.concat(appDataRoute(routeParams.projectQuote, <ProjectPage section={ProjectSection.quotes} />));
        routes = routes.concat(appDataRoute(routeParams.projectSettings, <ProjectPage section={ProjectSection.settings} />));
        routes = routes.concat(appDataRoute(routeParams.projectQuincaillerie, <ProjectPage section={ProjectSection.quincaillerie} />));
        routes = routes.concat(appDataRoute(routeParams.scanProductsMode, <ScanProductsModeView />));
        routes = routes.concat(appDataRoute(routeParams.uploadTest, <UploadTest />));
        routes = routes.concat(appDataRoute(routeParams.labeler, <Labeler />));
        routes = routes.concat(appDataRoute(routeParams.labelerPrint, <LabelerPrint />));


    }

    if (isSuperAdmin) {
        routes = routes.concat(appDataRoute(routeParams.contact, <Contact />));
        routes = routes.concat(appDataRoute(routeParams.contacts, <Contacts />));
        routes = routes.concat(appDataRoute(routeParams.companies, <Companies />));
        routes = routes.concat(appDataRoute(routeParams.company, <Company />));
        routes = routes.concat(appDataRoute(routeParams.parametres, <AppSettings />));
        routes = routes.concat(appDataRoute(routeParams.authSystem, <SystemLogin />));
    }


    // doit être le dernier !
    routes.push({
        path: '*',
        element: <NotFound />
    });
    return routes;
};

export const AppRoutes = () => {

    const { isSuperAdmin, user } = useSession();
    const onLine = useSelector((state: AppState) => state.document.onLine);
    const title = useSelector((state: AppState) => state.document.title);

    const [router, setRouter] = React.useState<any>();

    const gen = () => {
        clearRouteData();
        var r = generateRoutes(isSuperAdmin, user);
        setRouter(createBrowserRouter(r));
    };

    React.useEffect(() => {
        void gen();
    }, [isSuperAdmin, user?.id]);

    React.useEffect(() => {
        document.title = title;
    }, [title]);

    if (!onLine) return <NoConnectionView />;
    if (!router) return <></>;
    return <RouterProvider router={router} />;
    /*
    return <MasterViewPage><Routes>
        {isSuperAdmin && SuperAdminRoutes()}
        {!!user && LoggedInRoutes()}
        {AppRoute(routeParams.projectList, <ProjectList />)}
        <Route path={'/auth/invitation/:hash'} element={<UserInvitation />} />
        <Route path={'/auth/login'} element={<LoginView />} />
        <Route path={'/verifyAccount'} element={<VerifyAccountView />} />
        <Route path={'/verifycode'} element={<VerifyCodeView />} />
        <Route path={'/auth/onlogin'} element={<OnLoginView />} />
        <Route path={'/'} element={<HomeView />} />
    </Routes></MasterViewPage>;
    */
};
/*
const SuperAdminRoutes = () => {
    return <><Route path={'/monitor'} element={<Monitor />} />
        {AppRoute(routeParams.labeler, <Labeler />)}
        <Route path={'/client/liste'} element={<CustomerList />} />
        {AppRoute(routeParams.contact, <Contact />)}
        {AppRoute(routeParams.contacts, <Contacts />)}
        {AppRoute(routeParams.companies, <Companies />)}
        <Route path={'/company/:id'} element={<Company />} />
        {AppRoute(routeParams.parametres, <AppSettings />)}
    </>;
};
const LoggedInRoutes = () => {
    return <>
        <Route path={'/outils/creer'} element={<NewTool />} />
        <Route path={'/outils'} element={<ToolsHomeView />} />
        {AppRoute(routeParams.users, <Users />)}
        {AppRoute(routeParams.products, <ProductList />)}
        <Route path={'/user/:id'} element={<UserView />} />
        {AppRoute(routeParams.project, <ProjectPage section={ProjectSection.contacts} />)}
        {AppRoute(routeParams.projectContacts, <ProjectPage section={ProjectSection.contacts} />)}
        {AppRoute(routeParams.projectQuotes, <ProjectPage section={ProjectSection.quotes} />)}
        {AppRoute(routeParams.projectQuote, <ProjectPage section={ProjectSection.quotes} />)}
        {AppRoute(routeParams.projectSettings, <ProjectPage section={ProjectSection.settings} />)}

        {/*<Route path={'/project/:id/quotes'} element={<ProjectPage section={ProjectSection.quotes} />} />
        <Route path={'/project/:id/quote/:quoteId'} element={<ProjectPage section={ProjectSection.quotes} />} />
        <Route path={'/project/:id/contacts'} element={<ProjectPage section={ProjectSection.contacts} />} />
        <Route path={'/project/:id/settings'} element={<ProjectPage section={ProjectSection.settings} />} />*///}
/*</>;
};

*/
